/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TastemakerNotificationAction } from './TastemakerNotificationAction';
import {
    TastemakerNotificationActionFromJSON,
    TastemakerNotificationActionFromJSONTyped,
    TastemakerNotificationActionToJSON,
} from './TastemakerNotificationAction';

/**
 * 
 * @export
 * @interface TastemakerNotification
 */
export interface TastemakerNotification {
    /**
     * 
     * @type {string}
     * @memberof TastemakerNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TastemakerNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof TastemakerNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof TastemakerNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<TastemakerNotificationAction>}
     * @memberof TastemakerNotification
     */
    actions: Array<TastemakerNotificationAction>;
}

/**
 * Check if a given object implements the TastemakerNotification interface.
 */
export function instanceOfTastemakerNotification(value: object): value is TastemakerNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function TastemakerNotificationFromJSON(json: any): TastemakerNotification {
    return TastemakerNotificationFromJSONTyped(json, false);
}

export function TastemakerNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TastemakerNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(TastemakerNotificationActionFromJSON)),
    };
}

export function TastemakerNotificationToJSON(value?: TastemakerNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(TastemakerNotificationActionToJSON)),
    };
}

